module.exports = __webpack_public_path__ + "static/media/carta_82.bd335aff.jpg";